import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TrainingCentersService } from 'projects/services/src/app/API/training-centers.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Location } from '@angular/common';
import { TimeDuration } from 'projects/common/src/app/types';
import * as moment from 'moment';
import { PdfService } from 'projects/services/src/app/API/document/pdf.service';
import { FileService } from 'projects/services/src/app/API/document/file.service';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { ValidationService } from 'projects/services/src/app/validation.service';
import { SmartService } from 'projects/services/src/app/API/smartservice/smart.service';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { PaymentService } from 'projects/services/src/app/API/payment.service';
import { ToasterService } from 'projects/services/src/app/API/toaster.service';



declare const swal: any;

@Component({
	selector: 'app-payment-history',
	templateUrl: './payment-history.component.html',
	styleUrls: ['./payment-history.component.css']
})
export class PaymentHistoryComponent implements OnInit {
	loggedInUserInfo: any;
	// AssessmentTcRequest = [];
	// getPaymentHistoryReports: any;
	// paymentData: any;
	paymentData = [];
	count: any;
	itemsPerPage: Number;
	pageNo: Number;
	refundBankDetailsForm: FormGroup;
	otpPaymentForm: FormGroup;
	trainingCentreDetails: { userName: '' }
	// selectedRefundRequest: any;
	selectedRefundRequest: { _id: string, userName: string, feeDescription: string, eligibleForRDG: string } = { _id: '', userName: '', feeDescription: '', eligibleForRDG: '' }
	localFileName = {
		documentUploaded: '',
		localFile: ''
	}
	eligbleForPayments = false;
	arrforPayments: any;
	statusColor = { 'true': '#8dc63f' };
	conversationHistory: any;
	processType: any;

	durationFields: any = new TimeDuration('', [
		{
			name: 'fromDate',
			placeholder: 'Start Date',
			id: 'startDate',
			value: ''
		},
		{
			name: 'toDate',
			placeholder: 'End Date',
			id: 'endDate',
			value: ''
		}
	], {
			row: true,
			required: true,
			labelDiv: 4,
			inputDiv: 4
		});
	transaction_from = 'transactionFromDate';
	transaction_to = 'transactionToDate';
	transaction = {
		isComplete: 'true'
	};
	merchantId = {
		merchantId: 'sequenceId'
	}
	userName = false;
	errMsgID = '';
	searchBy = '';
	errMsgDate = '';
	accessType: String = 'write';
	AssessmentTcRequest = [];
	schemeApprovedDetails: any;
	selectedTrainingCenterRequest: any;
	// tcFilterForm: FormGroup;
	filterForm: FormGroup;
	trainingCenterRequests: any;
	// paymentData: any;
	length: any;
	trasactionIds: any = {};
	tpDetails: any;

	constructor(
		private formBuilder: FormBuilder,
		private router: Router,
		private pdfService: PdfService,
		private paymentService: PaymentService,
		private toasterservice: ToasterService,
		private fileService: FileService,
		private location: Location,
		private activateRouter: ActivatedRoute,
		private trainingCentersService: TrainingCentersService,
		private currentUserService: CurrentUserService,
		private smartService: SmartService) {
	}

	ngOnInit() {
		this.pageNo = 0;
		this.itemsPerPage = 10;
		this.loggedInUser();
		this.refundBankDetailsForm = this.formBuilder.group({
			// tcId: ['', [Validators.required]],
			branchName: ['', [Validators.required]],
			declaration: ['', [Validators.required]],
			bankName: ['', [Validators.required, Validators.pattern('^([A-Za-z]+ )+[A-Za-z]+$|^[A-Za-z]+$')]],
			accountNumber: ['', [Validators.required, Validators.pattern('[0-9]{9,18}')]],
			ifscCode: ['', [Validators.required, Validators.pattern('^[A-Za-z]{4}[a-zA-Z0-9]{7}$')]],
			accountHolderName: ['', [Validators.required, Validators.pattern('^([A-Za-z]+ )+[A-Za-z]+$|^[A-Za-z]+$')]],
			// documentUploaded: ['', [Validators.required]],
			documentUploaded: ['', [Validators.required,
			ValidationService.fileTypeValidator('pdf', 'jpeg', 'png', 'jpg'),
			ValidationService.fileSizeValidator(5),
			ValidationService.fileValidator]],
		});
		this.filterForm = this.formBuilder.group({
			date: ['', [ValidationService.dateDurationValidation()]],
		})
		this.otpPaymentForm = this.formBuilder.group({
			otp: ['', Validators.required]
		});
		// this.getTCRequests();
		// this.searchFilter(this.pageNo, this.itemsPerPage);
	}
	loggedInUser() {
		this.currentUserService.getCurrentUser()
			.subscribe(res => {
				this.loggedInUserInfo = res;
				this.getPaymentHistoryReports();

			})
	}
	// getTCRequests() {
	// 	this.trainingCentersService.getAllTCPayments()
	// 		.subscribe(tcRequests => {
	// 			if (tcRequests.data !== null) {
	// 				this.paymentRequest = tcRequests.data;
	// 			}
	// 		});
	// }
	checkAmount(payment, index) {
		console.log(payment);
		this.trainingCentersService.getAmountofTC(payment.userName, payment.merchantId)
			.subscribe(res => {
				console.log(res);
				if (res) {
					// swal(
					// 	'You have to pay' + res,

					// );
					swal({
						title: `You have to pay ${res.amount} rupee only`,
						type: 'info'
						// showCancelButton: true,
						// cancelButtonText: 'Cancel',
						// cancelButtonColor: '#d33',
					})
				}

			})

	}

	checkRole(type) {
		if (type === 'Training Centre') {
			return true;
		} else {
			return false;
		}
	}

	// onRequiredPerPageChage(itemsPerPage) {
	// 	this.itemsPerPage = itemsPerPage;
	// 	this.getPaymentHistoryReports();
	// }


	// onPageChange(pageNo) {
	// 	this.pageNo = pageNo - 1;
	// 	this.getPaymentHistoryReports();
	// 	}

	getPaymentHistoryReports() {
		const isComplete = true;
		// '&isComplete=' + isComplete +
		const queryParams = 'reportName=paymentDtlsReport&itemsperpage=' +
			this.itemsPerPage + '&pageNo=' + this.pageNo + '&userName=' + this.loggedInUserInfo.userName;
		this.trainingCentersService.getInprocessTCPaymentReports(queryParams).subscribe(response => {
			this.paymentData = response.data;
			this.count = response.count;
			console.log('Mypayment', this.paymentData);

			// console.log("Mypayment",this.paymentData);
		});
	}

	// downloadCertificate(value) {
	// 	this.fileService.downloadAttachedFile(value);
	// }

	// convertDateFormat(date) {

	// 	if (date) {
	// 		const splittedDate = date.split(' ')
	// 		// 	console.log("-->s;itted", splittedDate)
	// 		return splittedDate[0]
	// 	}
	// 	return null
	// }

	// downloadFile(fileKey) {
	// 	this.fileService.downloadAttachedFile(fileKey);
	// }
	goBack() {
		this.location.back();
	}
	// downloadCertificate(value, _id) {
	// 	if (value) {
	// 		this.fileService.downloadAttachedFile(value);

	// 	} else {
	// 		this._generateInvoicePdf(_id)
	// 	}
	// }
	// _generateInvoicePdf(orderId) {
	// 	if (orderId) {
	// 		const payload = {
	// 			'orderId': orderId,
	// 			'payKey': true
	// 		}
	// 		this.paymentService._getInvoicesDownload(payload).subscribe(res => {
	// 			if (res.receiptPath) {
	// 				this.fileService.downloadAttachedFile(res.receiptPath);
	// 			} else {
	// 				this.totservice.showWarningToaster('Receipt Name Not Found');
	// 			}
	// 		})
	// 	} else {
	// 		this.totservice.showWarningToaster('Order Id Missing!');
	// 	}

	// }
	applyForRefund(selectedRequest, processType?) {
		this.refundBankDetailsForm.reset();
		this.selectedRefundRequest = selectedRequest;
		this.processType = processType;
		Helpers.openModal('refund-bank-details');

		// swal({
		// 	title: 'Disclaimer:',
		// 	text: "I hereby declare that all above information provided by me is correct in all aspect and in the event of any misinformation or inaccurate information, shall indemnify, keep indemnified, hold harmless, defend, protect and fully compensate NSDC.",
		// 	icon: 'warning',
		// 	showCancelButton: true,
		// 	confirmButtonColor: '#3085d6',
		// 	cancelButtonColor: '#d33',
		// 	confirmButtonText: 'Yes'
		// }).then((result) => {
		// 	if (result.value) {
		//  	Helpers.openModal('refund-bank-details');
		// 	} else {
		// 		Helpers.closeModal('refund-bank-details');
		// 	}
		// })
	}
	submitBankDetails() {
		const obj = {
			'tcId': this.selectedRefundRequest.userName,
			'paymentID': this.selectedRefundRequest._id.slice(13, this.selectedRefundRequest._id.length - 2),
		}
		if (this.refundBankDetailsForm.valid) {
			this.smartService.getPaymentOTP(obj).subscribe(res => {
				if (res) {
				}
			}
			);
			this.otpPaymentForm.reset();
			Helpers.openModal('payment_otp');
		}
	}
	verifiedOtp() {
		const verifyOtp = {
			'tcId': this.selectedRefundRequest.userName,
			'paymentID': this.selectedRefundRequest._id.slice(13, this.selectedRefundRequest._id.length - 2),
			'emailOtp': (this.otpPaymentForm.get('otp').value).toString()
		}
		if (this.otpPaymentForm.valid) {
			this.smartService.verifiedOTP(verifyOtp).subscribe(res => {
				const payLoad = {
					'bankDetails': {
						'tcId': this.selectedRefundRequest.userName,
						'branchName': this.refundBankDetailsForm.get('branchName').value,
						'bankName': this.refundBankDetailsForm.get('bankName').value,
						'accountNumber': this.refundBankDetailsForm.get('accountNumber').value,
						'ifscCode': (this.refundBankDetailsForm.get('ifscCode').value).toUpperCase(),
						'accountHolderName': this.refundBankDetailsForm.get('accountHolderName').value,
						'documentUploaded': this.refundBankDetailsForm.get('documentUploaded').value
					},
					'paymentID': this.selectedRefundRequest._id.slice(13, this.selectedRefundRequest._id.length - 2),
					'referenceType': this.selectedRefundRequest.feeDescription,
					'eligibleForRDG': this.selectedRefundRequest.eligibleForRDG === 'true' ? true : false,
					'processType': this.processType
				}
				if (res) {
					this.smartService.applyRefundDuplicateEntries(payLoad)
						.subscribe(res => {
							if (res) {
								swal({
									title: 'Your Application for Refund is Successful',
									type: 'success'
								}).then((resultValue: any) => {
									if (resultValue.value) {
										this.getPaymentHistoryReports();
									}
								})
							}
						})
				}
			});
			Helpers.closeModal('refund-bank-details');
		}
	}
	canApplyforrefundDuetoguidlinesChange(paymentRequest) {

		if (paymentRequest.eligibleForRDG === 'true') {
			if (!paymentRequest.hasOwnProperty('paymentRefundStatus')) {
				return true
			} else if (paymentRequest.paymentRefundStatus === 'TP Rejected'
				|| paymentRequest.paymentRefundStatus === 'Reject') {
				return true
			}
		} else if (paymentRequest.paymentRefundStatus === 'Approve' ||
			paymentRequest.paymentRefundStatus === 'Pending' ||
			paymentRequest.paymentRefundStatus === 'TP Approved'
			|| paymentRequest.paymentRefundStatus === 'Pending at TP') {
			return false
		}
	}
	canApplyforrefund(paymentRequest) {
		if (paymentRequest.paymentRefundStatus === 'Pending') {
			return false
		} else {

			if (paymentRequest.transactionResult && (paymentRequest.transactionResult === 'Success'
				|| paymentRequest.transactionResult === 'SuccessD'
				|| paymentRequest.transactionResult === 'success')) {
				if (paymentRequest.hasOwnProperty('eligibleForRDG')) {
					if (paymentRequest.eligibleForRDG === 'true') {
						return false
					} else {
						return true
					}
				} else if (paymentRequest.paymentRefundStatus === 'Approve'
					|| paymentRequest.paymentRefundStatus === 'Pending') {
					return false
				} else {
					return true
				}
			} else {
				return false
			}
		}


	}
	canApplyforrefundReinsReAccr(paymentRequest) {
		if (paymentRequest.paymentRefundStatus === 'Pending') {
			return false
		} else {
			if (paymentRequest.migration && paymentRequest.migration === 'SMART') {
				if (paymentRequest.feeDescription &&
					(paymentRequest.feeDescription === 'Re - Accreditation Fee'
						|| paymentRequest.feeDescription === 'Re-Accreditation Fee'
						|| paymentRequest.feeDescription === 'Re-Inspection Fee')) {

					if (paymentRequest.transactionResult && (paymentRequest.transactionResult === 'Success'
						|| paymentRequest.transactionResult === 'SuccessD'
						|| paymentRequest.transactionResult === 'success')) {
						if (paymentRequest.hasOwnProperty('eligibleForRDG')) {
							if (paymentRequest.eligibleForRDG === 'true') {
								return false
							} else {
								return true
							}
						} else if (paymentRequest.paymentRefundStatus === 'Approve'
							|| paymentRequest.paymentRefundStatus === 'Pending') {
							return false
						} else {
							return true
						}
					} else {
						return false
					}
				} else {
					return false
				}
			} else {
				return false
			}
		}

	}
	canCheckAmount(paymentRequest) {
		if (paymentRequest.eligibleForRDG === 'true') {
			return true
		} else {
			return false
		}
	}

	getRefundStatus(payment) {
		const status = payment.paymentRefundStatus ? payment.paymentRefundStatus : null
		return {
			'Approve': 'Approved', 	// financespoc approve
			'Reject': 'Rejected',	// financespoc reject
			'Pending': 'Pending',	// financespoc
			'Request for Refund': 'New Request',
			'Refund Not Done': 'Refund Not Done',
			'Refund Done': 'Refund Done',
			'TP Rejected': 'TP Rejected', // refund request rejected by TP in Case of Refund due to guidlines
			'TP Approved': 'TP Approved', // refund request approved by TP in Case of Refund due to guidlines,
			'Pending at TP': 'Pending at TP'
		}[status]
	}
	viewCommentsDetails(selectedType) {
		console.log(selectedType)
		this.smartService.getPaymenRefundArrovalComents(selectedType._id.slice(13, selectedType._id.length - 2))
			.subscribe(
				res => {
					this.conversationHistory = res;
					Helpers.openModal('history')
				}
			)
	}

	//


	convertDateFormat(date) {

		if (date) {
			const splittedDate = date.split(' ')
			// console.log('-->s;itted', splittedDate)
			return splittedDate[0]
		}

		return null
	}
	apply() {
		this.errMsgDate = '';
		let dataToSend;
		let dateObj;
		if (this.filterForm.get('date').value) {
			if (!this.filterForm.get('date').value.toDate || !this.filterForm.get('date').value.fromDate) {
				this.errMsgDate = 'Please Select From Date & To Date';
				return false
			}
			dateObj = {
				transactionto: this.filterForm.get('date').value.toDate,
				transactionfrom: this.filterForm.get('date').value.fromDate
			}
			dateObj['transactionfrom'].setHours(0, 0, 0, 0);
			dateObj['transactionto'].setHours(23, 59, 59, 999);
			dateObj['transactionfrom'] = dateObj['transactionfrom'].toISOString();
			dateObj['transactionto'] = dateObj['transactionto'].toISOString();
			dataToSend = Object.assign({}, dateObj, dataToSend);
		}

		if (this.trasactionIds[this.merchantId.merchantId]) {
			dataToSend = Object.assign({}, this.trasactionIds, dataToSend)
		}
		if (this.transaction.isComplete === 'true') {
			dataToSend = Object.assign({}, this.transaction, dataToSend)
		}
		console.log(dataToSend);
		dataToSend = dataToSend ? Object.assign(dataToSend, { reportName: 'paymentDtlsReport' }) : { reportName: 'paymentDtlsReport' };
		this.trainingCentersService.getTCPaymentDownload(dataToSend).subscribe(response => {
			console.log(response);
			if (response) {
				// this.filterForm.reset();
				// this.merchantId.merchantId = 'userName';
				// this.transaction.isComplete = 'false';
				// this.trasactionIds = {};
				// this.trainingCentersService._downloadFile(response, 'Payment_Details_' + moment(new Date()).format('DD/MM/YYYY hh:mm:ss a') + '.xls');
				this.trainingCentersService._downloadFile(response, 'Payment_Details_' + moment(new Date()).format('DD/MM/YYYY') + '.xls');
			}
		}, error => {
			console.log(error);
		}
		);

	}
	getLoggedInUserDetails() {
		this.currentUserService.getCurrentUser()
			.subscribe(res => {
				if (res.access) {
					this.accessType = res.access
				}

			})
	}
	reset() {
		this.filterForm.reset();
		this.merchantId.merchantId = 'userName';
		this.transaction.isComplete = 'false';
		this.trasactionIds = {};
		this.getPaymentHistoryReports();
		// this.filterApply();
	}
	filterApply() {
		this.errMsgDate = '';
		let dateObj;
		if (this.filterForm.get('date').value) {
			if (!this.filterForm.get('date').value.toDate || !this.filterForm.get('date').value.fromDate) {
				this.errMsgDate = 'Please Select From Date & To Date';
				return false
			}
		}
		let queryParams = 'reportName=paymentDtlsReport&itemsperpage=' + this.itemsPerPage + '&pageNo=' + this.pageNo + '&userName=' + this.loggedInUserInfo.userName;;
		if (this.filterForm.get('date').value && this.filterForm.get('date').value.toDate && this.filterForm.get('date').value.fromDate) {
			dateObj = {
				fromDate: this.filterForm.get('date').value.fromDate,
				toDate: this.filterForm.get('date').value.toDate
			}

			// dateObj['fromDate']
			dateObj['toDate'].setHours(23, 59, 59, 999);
			// toDate.setHours(23, 59, 59, 999);
			queryParams += `&transactionfrom=${dateObj['fromDate'].toISOString()}&transactionto=${dateObj['toDate'].toISOString()}`;
		}
		this.trainingCentersService.getPaginationTCPaymentReports(queryParams).subscribe(response => {
			console.log(response);
			if (response && response.data) {
				this.paymentData = response.data;
				this.count = response.count;
				this.searchBy = 'date';
			}
		});
	}


	getStatus(status) {
		return {
			'completed': 'Completed',
			'notCompleted': 'Not Completed'

		}[status];
	}

	onRequiredPerPageChage(itemsPerPage) {
		this.itemsPerPage = itemsPerPage;
		switch (this.searchBy) {
			case 'date':
				this.filterApply();
				break;
			case 'attemts':
				this.searchByTransaction();
				break;
			case 'tranactionId':
				this.searchById()
				break;
			default:
				this.filterApply();
				break;
		}
	}

	onPageChange(pageNo) {
		this.pageNo = pageNo - 1;
		switch (this.searchBy) {
			case 'date':
				this.filterApply();
				break;
			case 'attemts':
				this.searchByTransaction();
				break;
			case 'tranactionId':
				this.searchById()
				break;
			default:
				this.filterApply();
				break;
		}
	}
	downloadCertificate(value, _id) {
		if (value) {
			this.fileService.downloadAttachedFile(value);

		} else {
			this._generateInvoicePdf(_id)
		}
	}
	// viewDetails(selectedRequest) {
	// 	this.financeSpocService.setData(selectedRequest);
	// 	this.router.navigate(['/financespoc/view-details']);
	// }
	getPDFLink(selectedTC) {
		const tcId = selectedTC
		const DataToSend = {
			userName: tcId,
			role: 'trainingcentre'
		};
		this.pdfService.generatePDF(DataToSend)
			.subscribe(res => {
				this.downloadCAAF(res.tcreport)
			});
	}
	downloadCAAF(fileKey) {
		this.fileService.downloadAttachedFile(fileKey);
	}

	_generateInvoicePdf(orderId) {
		if (orderId) {
			const payload = {
				'orderId': orderId,
				'payKey': true
			}
			this.paymentService._getInvoicesDownload(payload).subscribe(res => {
				if (res.receiptPath) {
					this.fileService.downloadAttachedFile(res.receiptPath);
				} else {
					this.toasterservice.showWarningToaster('Receipt Name Not Found');
				}
			})
		} else {
			this.toasterservice.showWarningToaster('Order Id Missing!');
		}

	}


	goToApplicatioStage(tcId) {
		this.router.navigate(['../application-stage', tcId], { relativeTo: this.activateRouter });
	}
	searchByTransaction() {
		let queryParams = 'reportName=paymentDtlsReport&itemsperpage=' + this.itemsPerPage + '&pageNo=' +
			this.pageNo + '&userName=' + this.loggedInUserInfo.userName;
		if (this.transaction.isComplete !== 'false') {
			queryParams += `&isComplete=${this.transaction.isComplete}`;
		}
		if (this.merchantId.merchantId && Object.keys(this.trasactionIds).length !== 0) {
			queryParams += `&${this.merchantId.merchantId}=${this.trasactionIds[this.merchantId.merchantId]}`;
		}
		this.trainingCentersService.getPaginationTCPaymentReports(queryParams).subscribe(response => {
			console.log(response);
			if (response && response.data) {
				this.paymentData = response.data;
				this.count = response.count;
				this.searchBy = 'attemts';
			}
		});
	}
	searchById() {
		this.errMsgID = '';
		if (!this.trasactionIds[this.merchantId.merchantId]) {
			this.errMsgID = 'Please Enter Merchant ID/Tranaction ID/User Name';
			return false;
		}
		let queryParams = 'reportName=paymentDtlsReport&itemsperpage=' + this.itemsPerPage + '&pageNo=' + this.pageNo + '&userName=' + this.loggedInUserInfo.userName;;
		if (this.merchantId.merchantId && Object.keys(this.trasactionIds).length !== 0) {
			queryParams += `&${this.merchantId.merchantId}=${this.trasactionIds[this.merchantId.merchantId]}`;
		}
		if (this.transaction.isComplete !== 'false') {
			queryParams += `&isComplete=${this.transaction.isComplete}`;
		}
		this.trainingCentersService.getPaginationTCPaymentReports(queryParams).subscribe(response => {
			console.log(response);
			if (response && response.data) {
				this.paymentData = response.data;
				this.count = response.count;
				this.searchBy = 'tranactionId';
			}
		});
	}
	getjobRoleFees(pay) {
		if (pay && pay.totalAmount && (pay.feeDescription === 'Inspection Fee' || pay.feeDescription === 'Re-Inspection Fee')) {
			let jobRoleFees = pay.residentialAmount ? (pay.totalAmount - pay.conversationFees - pay.residentialAmount - 10000) : (pay.totalAmount - pay.conversationFees - 10000)
			return jobRoleFees
		}
		return "-"
	}
}

